export default "__VITE_ASSET__c72f3aa0__"